<template>
  <v-menu v-model="menuVisible" :close-on-content-click="false" transition="slide-y-transition" max-width="300"
    offset-y>
    <template v-slot:activator="{ props }">
      <priotag class="my-auto chip-w-100 cursor-pointer w-100" full_with :prios="prios" :type="type"
        :selected="selected" :size="size" v-bind="props">
      </priotag>
      <div class="pl-4 pt-2 v-messages__message" style="color:rgb(var(--v-theme-error))"><small>{{ errorMessages
          }}</small></div>
    </template>

    <v-list density="compact" nav>
      <v-list-item v-for="item in prios" :key="item.value" @click="update(item.value)" class="px-1 py-0 cursor-pointer">
        <priotag class="my-auto chip-w-100" :prios="prios" :size="size" full_with :type="type" :selected="item.value" />
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: "StatusChipMenu",
  props: {
    type: { type: String, default: "chip" },
    selected: { type: Number, required: true },
    full_with: { type: Boolean, default: false },
    size: { type: String, default: "large" },
    ticket_id: { type: Number, default: null },
    errorMessages: { type: String, default: "" },
  },

  data: () => ({
    menuVisible: false,
    prios: [
      { id: 0, value: "none", name: "Geen", color: "#bbbbbb", icon: "fas fa-flag" },
      { id: 1, value: "low", name: "Laag", color: "#bbbbbb", icon: "fas fa-flag" },
      { id: 2, value: "normal", name: "Normaal", color: "#3e63dd", icon: "fas fa-flag" },
      { id: 3, value: "high", name: "Hoog", color: "#ffc53d", icon: "fas fa-flag" },
      { id: 4, value: "urgent", name: "Kritiek", color: "#c62a2f", icon: "fas fa-flag" },
    ],
  }),
  methods: {
    update(prio) {

      if (this.ticket_id) {
        this.$emit('update:value', { prio, ticketId: this.ticket_id });

      } else {
        this.$emit('update:value', prio);
      }
      this.menuVisible = false;
    }
  },
  computed: {
    // Get the selected status object from statuses array
    selectedItem() {
      return this.prios.find(item => item.id === this.selected) || null;
    },
    // Get color from selected status
    computedStatusColor() {
      return this.selectedItem ? this.selectedItem.color : "#ccc";
    },
  },
};
</script>
